export default __webpack_public_path__ + "static/media/welpentreffen_51.066dc35e.jpg";